(ns manatee.ui.subs
  (:require [manatee.app-db :as app-db]
            [manatee.ui.app-db :as db]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::view
 (fn view
   [db _]
   (db/get-view db)))

(rf/reg-sub
 ::config
 (fn config
   [db _]
   (app-db/get-config db)))

(rf/reg-sub
 ::menu-open?
 (fn menu-open?
   [db _]
   (db/get-menu-open? db)))
